/**
 * Helpers for datetime-local input values and API save format.
 */

/** Get YYYY-MM-DDTHH:mm for datetime-local input (local time), preserves time from stored value */
export function getDateTimeLocalValue(value: string | undefined): string {
  if (!value) return '';
  const str = String(value).trim();
  try {
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${y}-${m}-${day}T${hours}:${minutes}`;
    }
  } catch {
    /* ignore */
  }
  return '';
}

/**
 * Format datetime-local value (YYYY-MM-DDTHH:mm) for API.
 * Returns local time with timezone offset (e.g. 2026-03-05T05:30:00-07:00) so TrueContext
 * and other consumers get the same format as before; no UTC conversion, no milliseconds.
 */
export function formatDateTimeLocalForSave(datetimeLocal: string): string {
  if (!datetimeLocal || !datetimeLocal.includes('T')) return datetimeLocal;
  try {
    const d = new Date(datetimeLocal);
    if (isNaN(d.getTime())) return datetimeLocal;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const offsetMin = -d.getTimezoneOffset();
    const sign = offsetMin >= 0 ? '+' : '-';
    const offsetH = String(Math.floor(Math.abs(offsetMin) / 60)).padStart(2, '0');
    const offsetM = String(Math.abs(offsetMin) % 60).padStart(2, '0');
    return `${y}-${m}-${day}T${hours}:${minutes}:00${sign}${offsetH}:${offsetM}`;
  } catch {
    /* ignore */
  }
  return datetimeLocal;
}
